export default "__VITE_ASSET__865108a9__"